export class RequestDetails {
    'requestId';
    'requestTime';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "requestId",
            "baseName": "requestId",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestTime",
            "baseName": "requestTime",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return RequestDetails.attributeTypeMap;
    }
    constructor() {
    }
}
